import { render, staticRenderFns } from "./GoldenBook.vue?vue&type=template&id=2e405b24&scoped=true&"
import script from "./GoldenBook.vue?vue&type=script&lang=js&"
export * from "./GoldenBook.vue?vue&type=script&lang=js&"
import style0 from "./GoldenBook.vue?vue&type=style&index=0&id=2e405b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e405b24",
  null
  
)

export default component.exports